import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { ConfigService } from '@services/config.service';
import { lastValueFrom } from 'rxjs';

export const configResolver: ResolveFn<boolean> = async (route, state) => {
  const configService = inject(ConfigService);

  try {
    await lastValueFrom(configService.platformConfig());
  } catch {
    inject(Router).navigate(['/', 'help']);
    return false;
  }

  return true;
};
